import TelephonyContextProvider, { TelephonyContext } from './TelephonyContext'

export { TelephonyContext }
export default TelephonyContextProvider
